var checkbox = document.querySelector("input[name=warrantyCheckbox]");
// console.log("checkbox")
checkbox.addEventListener('change', function() {
  if (this.checked) {
    document.querySelector('input[name="items[0][id]"]').disabled = false;
  } else {
    document.querySelector('input[name="items[0][id]"]').disabled = true;
  }
});